import React, {Component} from 'react';
import Header from './Components/Header.js';
import Dashboard from './Components/Dashboard.js';
import NewAppointment from './Components/NewAppointment.js';
import Main from './Components/Main.js';
import MessagesContainer from './Components/MessagesContainer.js';
import Footer from './Components/Footer.js';
import PrivateRoute from './Components/PrivateRoute.js';
import AppointmentService from './utils/AppointmentService.js';
import LoginForm from './Components/LoginForm.js';
import CreateAccount from './Components/CreateAccount.js';
import './CSS/Template.css'
import * as Sentry from '@sentry/browser';
import Raven from 'raven-js';
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';
import { Switch, Route, Link, Redirect, BrowserRouter as Router } from 'react-router-dom'

class App extends Component {
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired
  };
  constructor(props) {
    const { cookies } = props;
    var loc = window.location;
    var url = new URL(loc)
    var enviorment_url = url.hostname
    var environment;
    if(enviorment_url == "booking-staging.getspiffy.com"){
      environment = 'staging';
    }
    else if(enviorment_url == "booking.getspiffy.com"){
      environment = 'production';
    }
    else {
      environment = 'development';
    }
    localStorage.setItem('environment', environment)
    super(props);
    //Raven.config('https://d726bc9f12eb4be68a884a1a911b6c6f@sentry.io/1244185').install();
   Sentry.init({
     dsn: "https://d726bc9f12eb4be68a884a1a911b6c6f@sentry.io/1244185",
     environment: environment
   });
    this.Appt = new AppointmentService()
  }
  componentWillMount(){
    var vars = {};
    var parts = document.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
        vars[key] = value;
    });
    if(vars['auth'] && vars['auth'].length > 0){
      localStorage.setItem('id_token', vars['auth'])
    }
    if(window.location.href && window.location.href.includes("auth"))
      window.location.href = window.location.href.split('?')[0];
    if(!localStorage.getItem('customer_id')){
      this.Appt.getUser()
      .then(res =>{
        if(res){
          localStorage.setItem('customer_id', res.id)
        }
        else{
        }
      })
    }
    this.watchID = navigator.geolocation.watchPosition((position) => {
      localStorage.setItem('lat', position.coords.latitude)
      localStorage.setItem('lng', position.coords.longitude)
    })
    if(!localStorage.getItem('lat') || !localStorage.getItem('lng')){
      localStorage.setItem('lat', 35.896780)
      localStorage.setItem('lng', -78.849640)
    }
  }
  componentDidCatch(error, errorInfo) {
    this.setState({ error });
    Sentry.withScope(scope => {
      Object.keys(errorInfo).forEach(key => {
        scope.setExtra(key, errorInfo[key]);
      });
      Sentry.captureException(error);
    });
  }
  render() {
    return (
        <div className='background' id="background">
          <Header />
          <Main />
          <MessagesContainer />
        </div>
    )
  }
}

export default withCookies(App);



// WEBPACK FOOTER //
// ./src/App.js